export const useDispositivoUsuario = () => {
  return {
    isDispositivoApple: /(iPhone|iPod|iPad|Macintosh).*AppleWebKit/i.test(navigator.userAgent),
  };
};
